import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
//import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { Router, NavigationExtras } from '@angular/router';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddcuisineComponent } from './addcuisine/addcuisine.component';
import { ExportgridComponent } from '../grid/exportgrid/exportgrid.component';
@Component({
  selector: 'app-cuisine',
  templateUrl: './cuisine.component.html',
  styleUrls: ['./cuisine.component.css']
})
export class CuisineComponent implements OnInit, AfterViewInit, OnDestroy {

  cuisineColl: any = [];

  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Cuisine";


  searchtxt: any = "";
  columnDefs = [
    { headerName: 'Cuisine', field: 'cuisinename' },
  ]

  gridOptions = {
    enableactioncol: true,
    columnDefs: this.columnDefs,
  };

  constructor(private appService: DhukanDataService, public router: Router, private productFindService: NgbModal,
    private confirmationDialogService: ConfirmationDialogService, private toastr: ToastrService, public loginService: LoginDataService) { this.fnServiceChanges(); }

  //User Check
   //User Check
   fnServiceChanges(){
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
          if(this.loginService.fnCheckUser()){                
              this.fnCheckPrivilage();
              if(this.isview){
                this.isloading=true;
                this.fnOnInitForm();
              }
              else{
                this.fnUserFailedForm();
              }    
          }
          else{
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnCompanyFaildRedirect();
        }
    });
  }


  ngOnInit() {
    try{
      if (this.loginService.fnCheckCompany()) {
      if(this.loginService.fnCheckUser()){         
        this.fnCheckPrivilage();
        if(this.isview){
          this.isloading=true;
          this.fnOnInitForm();
        }
        else{
          this.fnUserFailedForm();
        }          
      }
      else{
        this.loginService.fnGetUserRoleList();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }
    }catch(ex){
      this.fnShowErrorMsg(ex);
    }
  }
  fnOnInitForm() {
    this.fngetCuisine();
  }

  fnCheckPrivilage() {

    this.isadd = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE');
    this.isedit = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');
    this.isdelete = this.loginService.fnCheckUserRoleAction(this.formname, 'DELETE');
    this.isview = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW');
    this.isprint = this.loginService.fnCheckUserRoleAction(this.formname, 'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }



  ngAfterViewInit(): void {

  }

  ngOnDestroy(): void {

  }

  fngetCuisine() {

    if (this.showProgress) {
      return;
    }

    this.fnShowProgress();
    var data = {
      'cuisineid': 0,
      'companyid': this.loginService.fnGetCompanyId(), 
     
    }
    this.appService.getCuisine(data)
      .subscribe(
        (res) => {

          this.fnHideProgress();
          if (res.json().status == 200) {
            this.cuisineColl = res.json().result;
            this.fnSetDataTable();
          }
          else if (res.json().status == 400) {
            this.toastr.error('Error', res.json().err_field);
          }


        },
        (err) => {
          this.fnHideProgress();
          this.toastr.error('Error', err);
        })
  }

  fnAddCuisine() {
    try {
      const modalRef = this.productFindService.open(AddcuisineComponent, { size: <any>'m', backdrop: 'static' });


      modalRef.componentInstance.ngOnInit();

      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

        this.fngetCuisine();

      });


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnEditCuisine(pBO) {
  
    try {
    
      var deptid = pBO.cuisineid
      if (!this.isedit) {
        return;
      }
      const modalRef = this.productFindService.open(AddcuisineComponent, { size: <any>'m', backdrop: 'static' });
      modalRef.componentInstance.cuisineid = deptid;

      modalRef.componentInstance.ngOnInit();
      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

        this.fngetCuisine();

      });

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  public fnDeleteConfirm(pBO) {
    try {
      var deptid = pBO.cuisineid
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete Cuisine?')
        .then((confirmed) => {
          if (confirmed) {
            this.fnDeleteCuisine(deptid)
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnDeleteCuisine(deptid) {
    var data = {
      'cuisineid': deptid,
    }
    this.appService.fnDeleteCuisine(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.toastr.success('', " The Cuisine has been deleted successfully.");

            this.fnInsertActivityLog('DELETE', deptid, this.fnGetDescription(deptid));

            this.fngetCuisine();
          } else {
            this.toastr.error('', res.json().err_field);
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }







  private fnSetDataTable() {

  }


  fnPrintData() {
    try {


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnExportData() {
    try {


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  
  fnActionExportClick()  {
    const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
    modalRef.componentInstance.doctype = this.formname;
    modalRef.componentInstance.columnDefs = this.columnDefs;
    modalRef.componentInstance.contentColl = this.cuisineColl;
    modalRef.componentInstance.fnSetTable();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
  
    
    });
  }

  fnGetDescription(id) {
    const index = this.cuisineColl.findIndex(sku => sku.cuisineid === id);

    if (index) {
      return this.cuisineColl[index].productgroup;
    }
    else {
      return "";
    }

  }

  public fnSearchDatatable(value) {


  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res)=>{
        },
        (err)=>{

        });

    } catch {

    }
  }



  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }




}
